import { render, staticRenderFns } from "./ModuleSettingComponent.vue?vue&type=template&id=10466f37&scoped=true&"
import script from "./ModuleSettingComponent.vue?vue&type=script&lang=js&"
export * from "./ModuleSettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSettingComponent.vue?vue&type=style&index=0&id=10466f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10466f37",
  null
  
)

export default component.exports